import { Injectable } from '@angular/core';
import { I18NextPipe } from 'angular-i18next';
import * as moment from 'moment';
import { Moment } from 'moment';
import { gridItem } from 'src/app/models';
import { DashboardService } from './dashboard.service';
import { EnvironmentService } from './environmet.service';


@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private dashboardsService: DashboardService, private i18nextPipe: I18NextPipe) { }

  calculateRelativeDate(modelName, gridItem): Moment {
    const d = moment().utcOffset(0);
    if (!gridItem.setup?.period) { return d; }

    let model = gridItem.setup.period[modelName + 'DateType'];
    let value = gridItem.setup.period[modelName + 'Value'];

    d.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    if (model > 1 && value == null) return d;

    switch (model) {
      case 0:
        return d;
      case 1:
        return d.add(-1, "d");
      case 2:
        return d.day(value + 1);
      case 3:
        return d.add(-1, "w").day(value + 1);
      case 4:
        break;
      case 5: d.add(-1, "M"); break;
      case 6: d.set("M", 0); break;
      default: return d;
    }
    if (d.daysInMonth() < value)
      return d.endOf("M").set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
    d.set("date", value);
    return d;
  }

  reportInfoLine(gridItem: gridItem, reportLastReportTime: Date, serviceNumber: string): string {
    let reportInfo = `${this.i18nextPipe.transform('dashboard:Customer')}: ${EnvironmentService.customer} / `;
    if (serviceNumber) {
      reportInfo += `${this.i18nextPipe.transform('dashboard:Service Number')}: ${serviceNumber} / `;
    }
    let period = gridItem.setup?.period;
    let lastReportTime = moment(reportLastReportTime).format("HH:mm");
    if (period?.type == 1) {
      let from = this.calculateRelativeDate("from", gridItem);
      let to = this.calculateRelativeDate("to", gridItem);
      let fromTime = period?.fromTime || "00:00";
      let toTime = period?.toTime || "24:00";
      if (toTime == "23:59") toTime = "24:00";
      if (period?.fromDateType == 0 && fromTime > lastReportTime) {
        fromTime = lastReportTime;
      }
      if (period?.toDateType == 0 && toTime > lastReportTime) {
        toTime = lastReportTime;
      }
      reportInfo += `${this.i18nextPipe.transform('dashboard:Time Period')}: ${from.format("L")}${fromTime == "00:00" ? "" : " " + fromTime} - ${to.format("L")}${toTime == "24:00" ? "" : " " + toTime} / `;
    } else {
      let from = moment(period?.from).utcOffset(0).locale("en-gb");
      let to = moment(period?.to).utcOffset(0).locale("en-gb");
      let fromTime = from.format("LT") == "00:00" ? "" : from.format("LT");
      let toTime = to.format("LT");
      let today = moment().utcOffset(0).startOf('day');
      from.startOf('day');
      to.startOf('day');

      if (today.isSame(from) && fromTime > lastReportTime) {
        fromTime = lastReportTime;
      }
      if (today.isSame(to) && toTime > lastReportTime) {
        toTime = lastReportTime;
      }
      fromTime = fromTime ? " " + fromTime : fromTime;
      toTime = toTime == "23:59" ? "" : " " + toTime;

      reportInfo += `${this.i18nextPipe.transform('dashboard:Time Period')}: ${from.format("L")}${fromTime} - ${to.format("L")}${toTime} / `;
    }
    let now = moment();
    reportInfo += `${this.i18nextPipe.transform('dashboard:Generated')}: ${now.format("L LT")} GMT+${now.utcOffset() / 60} `;
    return reportInfo;
  }

  getRelativeDateTimeInMinutes(modelName, gridItem):number{
    if (!gridItem.setup?.period) { return 0; }
    let values = (gridItem.setup.period[modelName + 'Time']??"").split(':');
    let result = parseInt(values[0]??"0")*60;
    result += parseInt(values[1]??"0");
    return result;
  }
}
